<script>
import {ProductsService} from "../services";

export default {
    name: "ProductForm",
    data() {
        return {
            productInitial: null,
            manufacturerAttributeName: 'proizvoditel',
            result: {
                css: '',
                header: '',
                id: null
            },
            snackData: {
                isOpen: false,
                color: '',
                text: ''
            }
        }
    },
    computed: {
        formInitialData() {
            if(!this.productInitial)
                return {};

            const {
                categoryParent, category,
                nameRu, nameUa,
                articleNumber, images,
                pack, price, attributes,
                descriptionRu, descriptionUa,
                regions, paymentWays, seller,
                selfShipment
            } = this.productInitial;

            const manufacturer = this.productInitial.attributes.enumAttributes.find(item => item.attributeSystemName === this.manufacturerAttributeName) || {};

            return {
                categoryParent, category,
                nameRu, nameUa,
                articleNumber, images,
                pack, price, manufacturer,
                attributes, descriptionRu, descriptionUa,
                regions, paymentWays, seller,
                selfShipment
            }
        },
    },
    methods: {
        getFormData(data) {
            const formData = new FormData();
            formData.append('id', this.id);
            Object.keys(data).forEach(key => {
                if(key === 'productImages') {
                    data[key].forEach(item => {
                        let name = 'images[]';
                        formData.append(name, item);
                    });
                } else {
                    formData.append(key, JSON.stringify(data[key]))
                }
            });

            return formData;
        },
        setInitial() {
            ProductsService.setLocale(this.$store.getters.appLanguage);
            ProductsService.getInitial(this.id)
                .then(res => {
                    this.productInitial = res.data;
                })
                .catch(err => {console.log(err)});
        },
        snackHandle(text, color, isOpen) {
            this.snackData.color = color;
            this.snackData.text = text;
            this.snackData.isOpen = isOpen;
        },
        removeImage(id) {
            if(this.$route.name === 'Products.Copy'){
                if (this.productInitial.images) {
                    const idx = this.productInitial.images.findIndex(item => item.id === id);
                    this.productInitial.images.splice(idx, 1);
                }
                return
            }

            const params = {
                id: this.id,
                imageID: id
            };

            ProductsService.removeProductImage(params)
                .then(res => {
                    if (this.productInitial.images) {
                        const idx = this.productInitial.images.findIndex(item => item.id === res.data);
                        this.productInitial.images.splice(idx, 1);
                    }

                    this.resetSnack();
                    this.setSuccessSnack();
                    this.setSnackText(this.$t('dataSuccessUpdated'));
                    this.openSnack();
                })
                .catch(err => {
                    this.resetSnack();
                    this.setDeleteSnack();
                    this.setSnackText(this.$t('dataErrorUpdated'));
                    this.openSnack();
                    console.log(err)
                });

        },
    }
}
</script>
